var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeb = function SvgWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.182 10A8.18 8.18 0 0 1 10 18.182M18.182 10A8.18 8.18 0 0 0 10 1.818M18.182 10H1.818M10 18.182A8.18 8.18 0 0 1 1.818 10M10 18.182c-2.045-2.727-6.136-9 0-16.364m0 16.364c5.891-6.546 2.455-13.636 0-16.364M1.818 10A8.18 8.18 0 0 1 10 1.818"
  })));
};
export default SvgWeb;